import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { withCarSelectorReducer, withCarSelectorSaga } from './withReducer';

import { getBrands } from './actions';

import {
  makeSelectIsLoading,
  makeSelectBrands,
  makeSelectModels,
  makeSelectVersions,
  makeSelectSelectedBrand,
  makeSelectSelectedModel,
  makeSelectSelectedModelName,
  makeSelectCar,
} from './selectors';

import messages from './messages';
import {FlexSection} from '../UIKit';
import Brand from './brand';
import Model from './model';
import Version from './version';
import Car from './car';

import 'react-select-search/style.css';
import './styles.scss';

class CarSelector extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.loadBrands();
  }

  render() {
    const {
      isLoading,
      brands,
      models,
      versions,
      selectedBrand,
      selectedModelName,
      selectedModel,
      car,
    } = this.props;
    const isBrandSelected =
      selectedBrand !== null &&
      selectedBrand !== undefined &&
      selectedBrand.length === 3;
    const isModelSelected =
      selectedModel !== null &&
      selectedModel !== undefined &&
      selectedModel.length > 0;

    const carName =
      car !== null &&
      car !== undefined &&
      car.hasOwnProperty('allestimento') &&
      car.hasOwnProperty('modello')
        ? `${car.brand.data.label} ${car.modello} ${car.allestimento}`
        : null;

    if (!Array.isArray(brands)){
      return null;
    }

    return (
      <div className="CarSelector">
        <Brand
          title={messages.brands.title}
          brands={brands}
          placeholder={messages.brands.defaultMessage}
        />
        {isBrandSelected && !car.id && (
          <Model
            title={messages.models.title}
            models={models}
            placeholder={messages.models.defaultMessage}
            isLoading={isLoading}
          />
        )}
        {isBrandSelected && car.id && (
          <FlexSection
            title={messages.models.title}
            children={selectedModelName || car.modello}
          />
        )}
        {isModelSelected && (!car.id || !car.is_custom) && (
          <Version
            title={messages.versions.title}
            versions={versions}
            placeholder={messages.versions.defaultMessage}
            isLoading={isLoading}
          />
        )}
        {isBrandSelected && (isModelSelected || car.id) && (
          <Car
            title={messages.car.title}
            selectedBrand={selectedBrand}
            selectedModel={selectedModelName || car.modello}
            carName={carName}
            car={car}
          />
        )}
      </div>
    );
  }
}

CarSelector.defaultProps = {};
CarSelector.propTypes = {
  loadBrands: PropTypes.func.isRequired,
};

export function mapDispatchToProps(dispatch) {
  return {
    loadBrands: () => dispatch(getBrands()),
  };
}

const mapStateToProps = createStructuredSelector({
  isLoading: makeSelectIsLoading(),
  brands: makeSelectBrands(),
  models: makeSelectModels(),
  versions: makeSelectVersions(),
  selectedBrand: makeSelectSelectedBrand(),
  selectedModel: makeSelectSelectedModel(),
  selectedModelName: makeSelectSelectedModelName(),
  car: makeSelectCar(),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withCarSelectorReducer,
  withCarSelectorSaga,
  withConnect,
)(CarSelector);
